var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_375_2177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7822 0.924965C15.9775 0.729702 15.9775 0.41312 15.7822 0.217858C15.587 0.0225956 15.2704 0.0225956 15.0751 0.217858L15.7822 0.924965ZM0.21798 15.075C0.0227177 15.2703 0.0227177 15.5868 0.21798 15.7821C0.413242 15.9774 0.729824 15.9774 0.925087 15.7821L0.21798 15.075ZM0.925087 0.217858C0.729824 0.0225956 0.413242 0.0225956 0.21798 0.217858C0.0227177 0.41312 0.0227177 0.729702 0.21798 0.924965L0.925087 0.217858ZM15.0751 15.7821C15.2704 15.9774 15.587 15.9774 15.7822 15.7821C15.9775 15.5868 15.9775 15.2703 15.7822 15.075L15.0751 15.7821ZM15.0751 0.217858L0.21798 15.075L0.925087 15.7821L15.7822 0.924965L15.0751 0.217858ZM0.21798 0.924965L15.0751 15.7821L15.7822 15.075L0.925087 0.217858L0.21798 0.924965Z",
    fill: "#091739"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_375_2177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross-icon.a4db0f73.svg";
export { ForwardRef as ReactComponent };